export default [
  { key: "en", name: "en", lab: "English" },
  // { key: "ko", name: "ko-KR", lab: "한국어" },
  { key: "ja", name: "ja", lab: "日本語" },
  { key: "hi", name: "hi", lab: "हिंदी" }, //印地语
  { key: "in", name: "id", lab: "Bahasa Indonesia" }, //印尼语
  { key: "ru", name: "ru", lab: "русский" }, //俄语
  { key: "hk", name: "zh-HK", lab: "繁体中文" },
  { key: "cn", name: "zh-CN", lab: "简体中文" },
  { key: "es", name: "es", lab: "Español" }, //西班牙语
  { key: "tr", name: "tr", lab: "Türkçe" }, //土耳其语
  { key: "vi", name: "vi", lab: "Tiếng Việt" }, //越南语
  { key: "th", name: "th", lab: "ภาษาไทย" }, //泰语

];

/*
export default [
  { key: "en", name: "en-US", lab: "English" },
  // { key: "ko", name: "ko-KR", lab: "한국어" },
  { key: "ja", name: "ja-JP", lab: "日本語" },
  { key: "hi", name: "hi-IN", lab: "हिंदी" }, //印地语
  { key: "in", name: "id-ID", lab: "Bahasa Indonesia" }, //印尼语
  { key: "ru", name: "ru-RU", lab: "русский" }, //俄语
  { key: "es", name: "es-ES", lab: "Español" }, //西班牙语
  { key: "tr", name: "tr-TR", lab: "Türkçe" }, //土耳其语
  { key: "hk", name: "zh-HK", lab: "繁体中文" },
  { key: "cn", name: "zh-CN", lab: "简体中文" },
  { key: "vi", name: "vi-VI", lab: "Tiếng Việt" }, //越南语
  { key: "th", name: "th-TH", lab: "ภาษาไทย" }, //泰语
];
 */
